export const BusinessUnitStatus = {
  active: "Active",
  inactive: "Inactive",
} as const;
export type BusinessUnitStatus =
  (typeof BusinessUnitStatus)[keyof typeof BusinessUnitStatus];

export interface RecalibrationEntry {
  month: string;
  prior_annual: number;
  new_annual: number;
  delta: number;
  prior_month_actual: number;
  prior_month_estimate: number;
  reason: "overrun" | "underrun" | "match";
  ran_at: Date | string;
}

export interface BusinessUnit {
  id?: string;
  _id?: any;
  name: string;
  code: string;
  status?: BusinessUnitStatus;
  created_at?: Date;
  created_by?: string;
  created_by_name?: string;
  updated_at?: Date;
  updated_by?: string;
  updated_by_name?: string;
  deleted?: boolean;
  // --- Phase 4
  annual_estimate?: number;
  current_fy?: string;
  monthly_slices?: number[];
  recalibration_history?: RecalibrationEntry[];
  // --- Phase 7C
  recurrence_months?: number;
}

/** Allowed cadence values — divisors of 12. */
export const ALLOWED_RECURRENCE_MONTHS = [1, 2, 3, 4, 6, 12] as const;

export const RECURRENCE_LABELS: Record<number, string> = {
  1: "Monthly",
  2: "Bi-monthly",
  3: "Quarterly",
  4: "Tri-annual",
  6: "Semi-annual",
  12: "Annual",
};

export const businessUnitDefaultValue: BusinessUnit = {
  name: "",
  code: "",
  status: "Active",
};

export interface BusinessUnitFilterData {
  page: number;
  count: number;
  search?: string;
  status?: string;
  sort?: string;
  sort_order?: number;
}
